import { render, staticRenderFns } from "./SavedFilterResults.vue?vue&type=template&id=641e7496&scoped=true&"
import script from "./SavedFilterResults.vue?vue&type=script&lang=js&"
export * from "./SavedFilterResults.vue?vue&type=script&lang=js&"
import style0 from "./SavedFilterResults.vue?vue&type=style&index=0&id=641e7496&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641e7496",
  null
  
)

export default component.exports